import React from "react";

const BusinessIcon = ({ color = "#424242", ...props }) => (
  <svg width={42} height={32} viewBox="0 0 42 32" {...props}>
    <path
      fill={color}
      d="M20 30v-8h-7v8h7zm2 0h7v-8h-7v8zM38.333 4.673l3.473 4.736A1 1 0 0 1 42 10v4.667a1 1 0 0 1-.026.225 5.082 5.082 0 0 1-1.64 2.719V31a1 1 0 0 1-1 1H2.666a1 1 0 0 1-1-1V17.61a5.102 5.102 0 0 1-1.641-2.718A1 1 0 0 1 0 14.667V10a1 1 0 0 1 .194-.591l3.473-4.736V1a1 1 0 0 1 1-1h32.666a1 1 0 0 1 1 1v3.673zm-2-.673V2H5.667v2h30.666zm.494 2H5.173L2 10.327v4.218a3.105 3.105 0 0 0 6.026-.103c.238-1.034 1.71-1.034 1.948 0a3.105 3.105 0 0 0 6.052 0c.238-1.034 1.71-1.034 1.948 0a3.105 3.105 0 0 0 6.052 0c.238-1.034 1.71-1.034 1.948 0a3.105 3.105 0 0 0 6.052 0c.238-1.034 1.71-1.034 1.948 0a3.105 3.105 0 0 0 6.026.103v-4.218L36.827 6zM3.667 18.672V30H11v-9a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9h7.333V18.673A5.103 5.103 0 0 1 33 16.917a5.106 5.106 0 0 1-8 0 5.106 5.106 0 0 1-8 0 5.106 5.106 0 0 1-8 0 5.106 5.106 0 0 1-5.333 1.755zm1.666-7.339a1 1 0 0 1 0-2h31.334a1 1 0 0 1 0 2H5.333z"
    />
  </svg>
);

export default BusinessIcon;
